export default __webpack_public_path__ + "static/media/blue-hill-header.7b16b837.svg";